import { render, staticRenderFns } from "./ProgressWorkflow.vue?vue&type=template&id=47481e64"
import script from "./ProgressWorkflow.vue?vue&type=script&lang=js"
export * from "./ProgressWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports